import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL } from "../lib/data";

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-slate-900 text-slate-300">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <div className="inline-flex items-center rounded-2xl bg-white px-4 py-2.5">
          <img src="/logo.png" alt="WM Clean" className="h-8 w-auto" />
        </div>
        <p className="mt-4 text-sm leading-relaxed text-slate-400">
          Nettoyage professionnel de vitres pour particuliers et professionnels à Lille et dans
          toute la métropole. Satisfait ou refait.
        </p>
        <div className="mt-5 flex gap-3">
          <a href="https://facebook.com" target="_blank" rel="noreferrer" data-testid="footer-social-facebook" aria-label="Facebook"
            className="w-10 h-10 rounded-full bg-slate-800 hover:bg-sky-600 flex items-center justify-center transition-colors">
            <Facebook size={17} />
          </a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer" data-testid="footer-social-instagram" aria-label="Instagram"
            className="w-10 h-10 rounded-full bg-slate-800 hover:bg-sky-600 flex items-center justify-center transition-colors">
            <Instagram size={17} />
          </a>
        </div>
      </div>

      <div>
        <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-white">Contact</h4>
        <ul className="mt-5 space-y-3 text-sm">
          <li>
            <a href={PHONE_TEL} data-testid="footer-phone-link" className="flex items-center gap-2.5 hover:text-sky-400 transition-colors">
              <Phone size={15} className="text-sky-400" /> {PHONE_DISPLAY}
            </a>
          </li>
          <li>
            <a href={`mailto:${EMAIL}`} data-testid="footer-email-link" className="flex items-center gap-2.5 hover:text-sky-400 transition-colors">
              <Mail size={15} className="text-sky-400" /> {EMAIL}
            </a>
          </li>
          <li className="flex items-center gap-2.5">
            <MapPin size={15} className="text-sky-400" /> Lille & Métropole lilloise
          </li>
        </ul>
      </div>

      <div>
        <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-white">Horaires</h4>
        <ul className="mt-5 space-y-3 text-sm text-slate-400">
          <li className="flex justify-between gap-6"><span>Lundi – Vendredi</span><span className="text-slate-200">8h – 19h</span></li>
          <li className="flex justify-between gap-6"><span>Samedi</span><span className="text-slate-200">9h – 17h</span></li>
          <li className="flex justify-between gap-6"><span>Dimanche</span><span className="text-slate-200">Fermé</span></li>
        </ul>
      </div>

      <div>
        <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-white">Navigation</h4>
        <ul className="mt-5 space-y-3 text-sm">
          <li><a href="#services" data-testid="footer-link-services" className="hover:text-sky-400 transition-colors">Nos services</a></li>
          <li><a href="#tarifs" data-testid="footer-link-tarifs" className="hover:text-sky-400 transition-colors">Tarifs</a></li>
          <li><a href="#avis" data-testid="footer-link-avis" className="hover:text-sky-400 transition-colors">Avis clients</a></li>
          <li><a href="#devis" data-testid="footer-link-devis" className="hover:text-sky-400 transition-colors">Devis gratuit</a></li>
          <li><a href="/admin" data-testid="footer-link-admin" className="hover:text-sky-400 transition-colors">Espace pro</a></li>
        </ul>
      </div>
    </div>

    <div className="border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
        <p>© 2026 WM Clean — Nettoyage de vitres à Lille. Tous droits réservés.</p>
        <a href="/mentions-legales" data-testid="footer-legal-link" className="hover:text-sky-400 transition-colors">Mentions légales & RGPD</a>
      </div>
    </div>
  </footer>
);
